import { Component, OnInit } from '@angular/core';
import { FeatureCategory, FeatureCellValue, FeatureRow, SUBSCRIPTION_FEATURE_CATEGORIES } from './subscription-features.data';

@Component({
    selector: 'subscription-features-table',
    template: require('./subscription-features-table.component.html'),
    styles: [require('./subscription-features-table.component.css')]
})
export class SubscriptionFeaturesTableComponent implements OnInit {
    readonly categories = SUBSCRIPTION_FEATURE_CATEGORIES;
    expandedCategoryIds = new Set<string>();
    expandedFeatureKeys = new Set<string>();

    ngOnInit() {
        this.categories.forEach((category) => {
            if (category.defaultExpanded) {
                this.expandedCategoryIds.add(category.id);
            }
            category.features.forEach((feature) => {
                if (feature.description) {
                    this.expandedFeatureKeys.add(this.featureKey(category, feature));
                }
            });
        });
    }

    featureKey(category: FeatureCategory, feature: FeatureRow): string {
        return category.id + ':' + feature.name;
    }

    hasExpandableDescription(feature: FeatureRow): boolean {
        return !!feature.description;
    }

    isExpanded(category: FeatureCategory): boolean {
        return this.expandedCategoryIds.has(category.id);
    }

    isFeatureExpanded(category: FeatureCategory, feature: FeatureRow): boolean {
        return this.expandedFeatureKeys.has(this.featureKey(category, feature));
    }

    toggleCategory(category: FeatureCategory) {
        if (this.expandedCategoryIds.has(category.id)) {
            this.expandedCategoryIds.delete(category.id);
        } else {
            this.expandedCategoryIds.add(category.id);
        }
    }

    toggleFeature(category: FeatureCategory, feature: FeatureRow) {
        const key = this.featureKey(category, feature);
        if (this.expandedFeatureKeys.has(key)) {
            this.expandedFeatureKeys.delete(key);
        } else {
            this.expandedFeatureKeys.add(key);
        }
    }

    cellLabel(value: FeatureCellValue): string {
        switch (value) {
            case 'lowOnly':
                return 'Low Value Only';
            case 'highOnly':
                return 'High Value Only';
            default:
                return '';
        }
    }

    isCheck(value: FeatureCellValue): boolean {
        return value === 'check';
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/subscription/subscription-features-table.component.ts